import { useEffect, useRef, useState } from "react";
import styles from "../../components/Report/BillingReportVersion2.module.css";

interface AutoPaginateProps {
  children: React.ReactNode;
  customMargin?: string | number;
  startPage?: number;
  onPagesCalculated?: (numPages: number) => void;
  isModal?: boolean;
}

const AutoPaginate: React.FC<AutoPaginateProps> = ({
  children,
  customMargin,
  startPage = 1,
  onPagesCalculated,
  isModal = true,
}) => {
  const [pages, setPages] = useState<JSX.Element[]>([]);
  const measureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!measureRef.current) return;

    const content = measureRef.current;
    //const pageHeight = 10.95 * 96 - 60;
    const pageHeight = isModal ? 10.95 * 96 - 60 : 10.8 * 96 - 60;
    const contentHeight = content.scrollHeight;

    if (contentHeight <= pageHeight) {
      setPages([
        <div
          key={0}
          className={styles.page}
          style={{
            marginBottom: customMargin,
            width: isModal ? "8in" : "calc(100% - 10px)",
            height: isModal ? "10.95in" : "10.8in",
            boxSizing: "border-box",
          }}
        >
          {children}
          <div className={styles.pageFooter}>Page {startPage}</div>
        </div>,
      ]);
      onPagesCalculated?.(1);
    } else {
      const numberOfPages = Math.ceil(contentHeight / pageHeight);
      const newPages: JSX.Element[] = [];

      for (let i = 0; i < numberOfPages; i++) {
        const offsetTop = i * pageHeight;

        newPages.push(
          <div
            key={i}
            className={styles.page}
            style={{
              marginBottom: customMargin,
              width: isModal ? "8in" : "calc(100% - 10px)",
              height: isModal ? "10.95in" : "10.8in",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                height: pageHeight,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  transform: `translateY(-${offsetTop}px)`,
                }}
              >
                {children}
              </div>
            </div>
            <div className={styles.pageFooter}>Page {startPage + i}</div>
          </div>
        );
      }

      setPages(newPages);
      onPagesCalculated?.(numberOfPages);
    }
  }, [children, customMargin, startPage, onPagesCalculated, isModal]);

  return (
    <>
      <div
        ref={measureRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          width: "8in",
          padding: "2rem",
          left: "-10000px",
          top: 0,
        }}
      >
        {children}
      </div>

      <div>{pages}</div>
    </>
  );
};

export default AutoPaginate;
